import { useState, useEffect } from 'react';

/**
 * Custom hook for managing editable state in DetailViews
 * Handles edit mode, saving state, and data synchronization
 */
export function useEditableState(initialData, onUpdate) {
  const [isEditMode, setIsEditMode] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [editedData, setEditedData] = useState(initialData);

  // Update editedData when initialData prop changes
  useEffect(() => {
    setEditedData(initialData);
    setIsEditMode(false);
  }, [initialData]);

  const handleSave = async () => {
    setIsSaving(true);
    try {
      await onUpdate?.(editedData);
      setIsEditMode(false);
    } catch (error) {
      console.error('Failed to update:', error);
      alert('Failed to save changes');
    } finally {
      setIsSaving(false);
    }
  };

  const handleCancel = () => {
    setEditedData(initialData);
    setIsEditMode(false);
  };

  const handleEdit = () => {
    setIsEditMode(true);
  };

  const updateField = (field, value) => {
    setEditedData({ ...editedData, [field]: value });
  };

  const toggleField = (field) => {
    const updated = { ...editedData, [field]: !editedData[field] };
    setEditedData(updated);
    onUpdate?.(updated);
  };

  return {
    isEditMode,
    isSaving,
    editedData,
    setEditedData,
    handleSave,
    handleCancel,
    handleEdit,
    updateField,
    toggleField
  };
}
